/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_NegotiationInputs */

const en_cases_filter_negotiation = /** @type {(inputs: Cases_Filter_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const pt_br2_cases_filter_negotiation = /** @type {(inputs: Cases_Filter_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociação`)
};

/**
* | output |
* | --- |
* | "Negotiation" |
*
* @param {Cases_Filter_NegotiationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_negotiation = /** @type {((inputs?: Cases_Filter_NegotiationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_NegotiationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_negotiation(inputs)
	return pt_br2_cases_filter_negotiation(inputs)
});